export default __webpack_public_path__ + "static/media/mail.19271de7.svg";